/**
 * UC-03: CalculateConnectivity
 * TOGAF Simulation context ABB — BFS from Core through Pipeline tiles.
 */
import type { Grid } from '../../../types';
import type { IAppLogger } from '../../domain/ports/IAppLogger';
import type { SimulationEngine } from '../../domain/services/SimulationEngine';

export interface CalculateConnectivityInput {
  grid: Grid;
}

export interface CalculateConnectivityOutput {
  grid: Grid;
}

export interface CalculateConnectivityDependencies {
  simulation: Pick<SimulationEngine, 'calculateConnectivity'>;
  logger?: IAppLogger;
}

export class CalculateConnectivityUseCase {
  constructor(private readonly deps: CalculateConnectivityDependencies) {}

  execute(input: CalculateConnectivityInput): CalculateConnectivityOutput {
    const grid = this.deps.simulation.calculateConnectivity(input.grid);

    this.deps.logger?.log('debug', 'connectivity.calculated', {
      connectedCount: grid.flat().filter((tile) => tile.isConnected).length,
    });

    return { grid };
  }
}